import React, { Component } from 'react';

const AccessData = (checkBoxData, headings, keyNames) => {

    const data = <div className="mb-2" style={{ maxHeight: '450px', overflowY: 'scroll' }}>
        <div className="mx-md-5 mx-1 mt-1 d-flex flex-row justify-content-between mb-2">
            {
                headings.map(
                    (data, i) => {
                        return <span key={i} className={`${data.textCenter === true ? `text-center` : `text-left`} font-weight-bold col-md-4 col-4 h5 mb-0`}>{data.name}</span>
                    }
                )
            }
        </div>
        {
            checkBoxData.map(
                (data, i) => {
                    return (<div key={i} className=" mx-md-5 mx-1 mt-1 d-flex flex-row justify-content-between align-items-center" style={{ borderBottom: '1px solid black' }}>
                        {
                            keyNames.map(
                                (keyName, j) => {
                                    const name = keyName.name
                                    return <span key={j} className="col-md-4 col-4">{data[name]}</span>
                                }
                            )
                        }
                        {
                            data.access === ' fa fa-check text-success' &&
                            <small className="text-center col-md-4 col-4"><i className="fa fa-check text-success fa-2x"></i></small>
                        }
                        {
                            data.access === ' fa fa-times text-danger' &&
                            <small className="text-center col-md-4 col-4"><i className="fa fa-times text-danger fa-2x"></i></small>
                        }
                    </div>)
                }
            )
        }
    </div>
    return data
}

export default AccessData;



// WEBPACK FOOTER //
// ./src/_components/common/AccessData/index.js